import {
  ITelemetryPlugin,
  IPlugin,
  IEventProperty,
  IExtendedConfiguration,
  IAppInsightsCore,
  ITelemetryItem,
  BaseTelemetryPlugin,
  IProcessTelemetryContext,
  extend
} from '@microsoft/1ds-core-js';
import { addOneDSFields } from './InternalUtils';
import { DataField } from '@microsoft/oteljs';

export class PartAPlugin extends BaseTelemetryPlugin implements ITelemetryPlugin {
  public identifier = 'PartAPlugin';
  // Plugins with lesser priority numbers are processed earlier.
  // Other commonly used plugins have these priorities:
  //   Properties     3
  //   WebAnalytics 180
  //   PrivacyGuard 499
  //   PostChannel 1011
  // We want PartAPlugin to happen before Privacy Guard, but after most of the other plugins.
  public priority = 450;
  private _properties: { [name: string]: IEventProperty | string | boolean } = {};

  initialize(_coreConfig: IExtendedConfiguration, _core: IAppInsightsCore, _extensions: IPlugin[]) {
    super.initialize(_coreConfig, _core, _extensions);
  }

  /**
   * Process the event and add part A fields to it.
   * @param {object} telemetryEvent - The event that needs to be stored.
   */
  processTelemetry(telemetryEvent: ITelemetryItem, itemCtx?: IProcessTelemetryContext) {
    // Try to use Browser-optimized Object.assign if it's available.
    // The typecast to "any" is required as this package is being built with target: "es5"
    // and Object.assign requires "es2015"
    // Notably, Object.assign does not do a deep merge, so if telemetryEvent.data contains
    // nested objects then this will result in data loss.
    if ((Object as any).assign) {
      (Object as any).assign(telemetryEvent.data, this._properties);
    } else {
      // Fallback to slow, custom JavaScript based merging for old browsers
      telemetryEvent.data = extend(telemetryEvent.data, this._properties);
    }

    let itemContext: IProcessTelemetryContext = this._getTelCtx(itemCtx);

    this.processNext(telemetryEvent, itemContext);
  }

  /**
   * Add properties to send on every event
   * @param properties Properties to send on every event
   */
  addDataFields(dataFields: DataField[]) {
    addOneDSFields(this._properties, dataFields, {
      prependDataToken: false,
      customerContentEnabled: false
    });
  }
}
